import React from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

import Spinner from '../../../components/Spinner';
import ErrorBox from '../../../components/ErrorBox';
import WCloud from './WCloud';

const fetchWordsInsights = async ({ queryKey }) => {
  const [, locationId] = queryKey;
  
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}api/v4/locachecker/wordsInsights`, {
    params: { locationId },
  });
  
  return data.data;
};

const WordsClouds = () => {
  const { locationId } = useParams();
  
  const {
    data: wordsInsights,
    isLoading,
    isError
  } = useQuery({
    queryKey: ['wordsInsights', locationId],
    queryFn: fetchWordsInsights,
    enabled: !!locationId,
  });
  
  if (isLoading) {
    return <Spinner height={635}/>;
  }
  
  if (isError) {
    return <ErrorBox description="We encountered an issue loading your Words Insights data. Please try again."/>;
  }
  
  return (
    <div className='flex gap-x-10'>
      <WCloud data={wordsInsights[0].positive} label={'Positive'} color={'#7ec95a'}/>
      <WCloud data={wordsInsights[0].negative} label={'Negative'} color={'#e55039'}/>
    </div>
  );
};

export default WordsClouds;
